import Fetch from './index'

export const getInvites = async (companyID) => {
    const params = new URLSearchParams({ companyID }).toString()
    return Fetch(`/user-invite?${params}`)
}

export const createInvite = async (email, companyID) => {
    return Fetch('/user-invite', {
        method: 'POST',
        body: JSON.stringify({ email, companyID }),
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export const deleteInvite = async (id) => {
    return Fetch(`/user-invite/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export const acceptInvite = async (token, name, password) => {
    return Fetch('/user-invite/accept', {
        method: 'POST',
        body: JSON.stringify({ token, name, password }),
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
